export const AUTH_ERRORS: { [key: string]: string } = {
    'auth/user-not-found': 'O e-mail ou a senha informados estão incorretos. <br> Revise seus dados e tente novamente.',
    'auth/invalid-email': 'Email inválido',
    'auth/wrong-password': 'O e-mail ou a senha informados estão incorretos. <br> Revise seus dados e tente novamente.',
    'auth/invalid-credential': 'O e-mail ou a senha informados estão incorretos. Revise seus dados e tente novamente.',
    'auth/email-already-in-use': 'Não foi possível concluir o cadastro. Verifique os dados informados e tente novamente.',
    'auth/email-already-exists': 'Não foi possível concluir o cadastro. Verifique os dados informados e tente novamente.',
    'auth/weak-password': 'Senha precisa ter no mínimo 6 caracteres',
    'auth/invalid-password': 'Senha precisa ter no mínimo 6 caracteres',
    'auth/user-disabled': 'Usuário desativado',
    'auth/argument-error': 'Erro no provedor de login',
    'auth/popup-closed-by-user': 'Popup de autenticação fechado pelo usuário',
    'auth/operation-not-allowed': 'Operação não permitida',
    'auth/requires-recent-login': 'Requer autenticação recente',
    'auth/password-does-not-meet-requirements': 'Senha não atende aos requisitos de segurança',
    'auth/invalid-action-code': 'Link inválido ou expirado',
    'auth/expired-action-code': 'Link inválido ou expirado',
    'auth/too-many-requests': 'Muitas tentativas. Tente novamente mais tarde.',
};

export const AUTH_ERRORS_EN: { [key: string]: string } = {
    'auth/user-not-found': 'Incorrect email or password',
    'auth/invalid-email': 'Invalid email',
    'auth/wrong-password': 'Incorrect username or password',
    'auth/invalid-credential': 'Incorrect username or password',
    'auth/email-already-in-use': 'Unable to complete registration. Check the information provided and try again.',
    'auth/email-already-exists': 'Unable to complete registration. Check the information provided and try again.',
    'auth/weak-password': 'Password must be at least 6 characters long',
    'auth/invalid-password': 'Password must be at least 6 characters long',
    'auth/user-disabled': 'Your account is currently under review by the Recruitment Team.',
    'auth/argument-error': 'Login provider error',
    'auth/popup-closed-by-user': 'Authentication popup closed by user',
    'auth/operation-not-allowed': 'Operation not allowed',
    'auth/requires-recent-login': 'Requires recent authentication',
    'auth/password-does-not-meet-requirements': 'Password does not meet security requirements',
    'auth/invalid-action-code': 'Invalid or expired link',
    'auth/expired-action-code': 'Invalid or expired link',
    'auth/too-many-requests': 'Too many attempts. Please try again later.',
};
